import { Component, OnInit, Input, OnChanges, OnDestroy, SimpleChanges, TemplateRef, ViewChild, EventEmitter, Output } from '@angular/core';
import { isNullOrUndefined } from 'util';

import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';

import { TableDefaultConstants } from '../common/constants/table.constant';
import { tableHeaderFixerDirective } from '../common/directives/table-header-fixer.directive';
import { DataTableService } from '../common/services/data-table.service';
import { DataTableEventsService } from '../common/services/datatable.events.service';


@Component({
  selector: 'lib-data-table',
  templateUrl: './datatable.component.html',
  styleUrls: ['./datatable.component.css']
})
export class DatatableComponent implements OnInit, OnChanges, OnDestroy {

  @Input() tableConfig: any;
  @Input() data: object;
  @Input() tableNameForDownload: string;
  @Input() loader: boolean;
  @Input() tableType: string;
  @Input() tableId: string;
  @Input() customTemplates: object;
  @Input() metaData: object;

  @Output() onRowClick = new EventEmitter<Object>();

  @ViewChild(tableHeaderFixerDirective, {
    static: false
  }) tablefixer: tableHeaderFixerDirective;

  sortOptions = TableDefaultConstants.sortOptions;
  tableData: any = {};
  masterRecordData: any;
  masterTotalData: any;
  noData: boolean = false;
  paginatorOptions: any;
  headerFixerOptions: any;
  headerCons: object[];
  totalRowConf: object;
  indexCons: object;
  templateConfig: TemplateRef<any>;
  private recordDataSub: Subscription;
  private totalDataSub: Subscription;
  private dataSub: Subscription;


  constructor(
    private tableService: DataTableService,
    private route: ActivatedRoute,
    private dataTableEventsService: DataTableEventsService
  ) { }

  ngOnInit() {
    if (this.tableConfig == undefined || this.tableData == undefined) {
      console.log("Please define proper table configuration and data to render the table data.")
      return;
    }
    this.updateStateData();
  }

  takeBackup = () => {
    this.masterRecordData = this.tableData.recordData ? JSON.parse(JSON.stringify(this.tableData.recordData)) : [];
    this.masterTotalData = this.tableData.totalData ? JSON.parse(JSON.stringify(this.tableData.totalData)) : [];
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.tableConfig == undefined || this.tableData == undefined) {
      console.log("Please define proper table configuration and data to render the table data.")
      return;
    }
    this.updateStateData();
  }

  getTemplateConfig(columnsTemplateMap: object) {
    if (!columnsTemplateMap || !this.tableConfig) return;

    // let templateConfig : object = {};
    this.templateConfig = (<any>({} as any));
    let columnsIDs = Object.keys(columnsTemplateMap);
    let count = {};
    let colIndexes = {};

    columnsIDs.forEach(column => {
      count[column] = 0;
      colIndexes[column] = [];
    })

    this.findIndexesOfColumns(columnsIDs, this.tableConfig['columns'], colIndexes, count);

    if (colIndexes) {
      for (let column in colIndexes) {
        if (!colIndexes[column] || colIndexes[column].length == 0) continue;

        colIndexes[column].forEach(index => {
          this.templateConfig[index] = columnsTemplateMap[column];
        })
      }
    }

    // return templateConfig;
  }

  findIndexesOfColumns(keys: Array<string>, columns: any, colIndexes: object, index: object) {
    if (columns instanceof Array) {
      columns.forEach((column) => {

        if (column['childs']) {
          this.findIndexesOfColumns(keys, column['childs'], colIndexes, index);
        }
        else {
          for (let i = 0; i < keys.length; i++) {
            if (column['jsonKey'] && column['jsonKey']['path'] && column['jsonKey']['path'].indexOf(keys[i]) != -1) {
              colIndexes[keys[i]].push(index[keys[i]]);
              break;
            }
          }
          for (let col in index) {
            index[col] = index[col] + 1;
          }
        }
      })
    }

    return colIndexes;
  }

  updateStateData() {
    this.recordDataSub = this.tableService.recordData.subscribe(data => {
      if (data.length == 0 || isNullOrUndefined(data)) {
        this.noData = true;
      } else {
        this.noData = false;
      }
      this.tableData.recordData = data;
    })
    this.totalDataSub = this.tableService.totalData.subscribe(data => {
      this.tableData.totalData = data;
    })
    this.dataSub = this.tableService.data.subscribe(data => {
      this.data = data;
      this.tableData.recordData = data;
      this.formatTable();
    })
    if (Object.keys(this.data).length == 0 || isNullOrUndefined(this.data)) {
      this.noData = true;
    } else {
      this.noData = false;
    }
    this.getTemplateConfig(this.customTemplates);
    this.totalRowConf = this.tableConfig.totalRow;
    this.paginatorOptions = this.tableConfig.paginatorOptions;
    this.headerFixerOptions = this.tableConfig.tableHeaderFixerInfo;
    this.headerCons = this.tableConfig.columns;
    this.indexCons = this.tableConfig.indexCons;

    // if(this.tableData.totalData && this.tableData.totalData.length == 0){      
    //   this.headerFixerOptions['rowFix'] = false;
    // }

    if (!isNullOrUndefined(this.tableConfig) && !isNullOrUndefined(this.tableConfig.sortOptions)) {
      this.sortOptions = this.tableConfig.sortOptions;
    }
    this.formatTable();

    setTimeout(() => {
      this.tablefixer.fixHeader();
      this.tablefixer.process();
    }, 1);
    this.dataTableEventsService.togglePage.subscribe(() => {
      setTimeout(() => {
        this.tablefixer.process();
      }, 1);
    })

    this.dataTableEventsService.sortOptions.subscribe(() => {
      setTimeout(() => {
        this.tablefixer.process();
      }, 1);
    })
    // if(!isNullOrUndefined(this.cons) && !isNullOrUndefined(this.cons.defaultSort)){
    //   this.sortOptions = {  sortOrder: this.cons.defaultSort };
    // }
  }

  formatTable() {
    switch (this.tableType) {

      case 'dataTable':
        this.tableData = this.tableService.formatTable(this.tableConfig, this.data);
        break;
      case 'treeTable':
        break;
      case 'crudTable':
        break;
      default:
        console.warn('Table type not found ! = ', this.tableType);
        break;
    }
    this.takeBackup();
  }

  click(element: any): void {
    this.onRowClick.emit(element);
  }

  ngOnDestroy() {
    this.recordDataSub.unsubscribe();
    this.totalDataSub.unsubscribe();
  }

}
